<template>
    <div id="payment" class="p-4 rounded-lg">
        <!-- Header with title and tabs -->
        <div class="flex justify-between">
            <div class="flex">
                <div class="flex items-center">
                    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_1413_30765" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                            width="34" height="34">
                            <rect width="34" height="34" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_1413_30765)">
                            <path
                                d="M10.433 23.7293H12.5579V17.0001H10.433V23.7293ZM21.4394 23.7293H23.5643V9.91679H21.4394V23.7293ZM15.9362 23.7293H18.0611V19.8335H15.9362V23.7293ZM15.9362 17.0001H18.0611V14.1668H15.9362V17.0001ZM7.51794 29.0418C6.80233 29.0418 6.19661 28.7938 5.70078 28.298C5.20495 27.8022 4.95703 27.1965 4.95703 26.4809V7.5194C4.95703 6.8038 5.20495 6.19808 5.70078 5.70225C6.19661 5.20641 6.80233 4.9585 7.51794 4.9585H26.4794C27.195 4.9585 27.8007 5.20641 28.2965 5.70225C28.7924 6.19808 29.0403 6.8038 29.0403 7.5194V26.4809C29.0403 27.1965 28.7924 27.8022 28.2965 28.298C27.8007 28.7938 27.195 29.0418 26.4794 29.0418H7.51794ZM7.51794 26.9168H26.4794C26.5884 26.9168 26.6883 26.8714 26.7791 26.7806C26.8699 26.6898 26.9153 26.5898 26.9153 26.4809V7.5194C26.9153 7.41042 26.8699 7.31051 26.7791 7.21967C26.6883 7.12887 26.5884 7.08346 26.4794 7.08346H7.51794C7.40895 7.08346 7.30904 7.12887 7.21821 7.21967C7.1274 7.31051 7.082 7.41042 7.082 7.5194V26.4809C7.082 26.5898 7.1274 26.6898 7.21821 26.7806C7.30904 26.8714 7.40895 26.9168 7.51794 26.9168Z"
                                fill="#003765" />
                        </g>
                    </svg>
                </div>
                <div class="text-xl font-bold flex items-center ml-1">รายรับ-รายจ่าย</div>
                
                <!-- Add this navigation button -->
                <button 
                    @click="navigateToExpensesPage" 
                    class="ml-2 px-2 py-1 bg-blue-100 text-blue-800 rounded-md text-xs hover:bg-blue-200 flex items-center"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                    ดูเพิ่มเติม
                </button>
            </div>
        </div>
        <div class="mt-4 w-full">
            <div class="flex w-full">
                <!-- Full width tab controls -->
                <div class="flex w-full">
                    <div @click="tab = 1" 
                        class="cursor-pointer text-center flex-1 py-2 transition-all"
                        :class="tab == 1 ? 'bg-blue-900 rounded-lg text-white' : 'text-gray-500'">
                        รายรับ
                    </div>
                    <div @click="tab = 2" 
                        class="cursor-pointer text-center flex-1 py-2 ml-2 transition-all"
                        :class="tab == 2 ? 'bg-blue-900 rounded-lg text-white' : 'text-gray-500'">
                        รายจ่าย
                    </div>
                </div>
            </div>
        </div>
            <div class="mt-1 w-full">
                <div class="flex w-full gap-2">
                    <div class="flex w-full">
                        <div
                            @click="setViewMode('monthly')"
                            class="cursor-pointer text-center flex-1 py-2 rounded-lg"
                            :class="viewMode === 'monthly' ? 'bg-blue-900 text-white' : 'bg-gray-100 text-gray-600'"
                        >
                            รายเดือน
                        </div>
                        <div
                            @click="setViewMode('all')"
                            class="cursor-pointer text-center flex-1 py-2 ml-2 rounded-lg"
                            :class="viewMode === 'all' ? 'bg-blue-900 text-white' : 'bg-gray-100 text-gray-600'"
                        >
                            ทั้งหมด
                        </div>
                    </div>

                    <div v-if="viewMode === 'monthly'" class="relative w-full">
                    <button 
                        @click="showDatePicker = !showDatePicker" 
                        class="h-9 px-2 text-center bg-blue-900 flex cursor-pointer text-white justify-center items-center rounded-xl mt-3 w-full"
                    >
                        {{ formatMonthYear(selectedDate) }}
                    </button>
                    <div v-if="showDatePicker" class="absolute top-full left-0 z-10 mt-1 bg-white shadow-lg rounded-lg p-4">
                        <div class="flex justify-between mb-2">
                        <button @click="changeYear(-1)" class="px-2 py-1 bg-gray-200 rounded">&lt;</button>
                        <div class="font-bold">{{ currentYear }}</div>
                        <button @click="changeYear(1)" class="px-2 py-1 bg-gray-200 rounded">&gt;</button>
                        </div>
                        <div class="grid grid-cols-3 gap-2">
                        <div
                            v-for="(month, index) in monthNames" 
                            :key="index"
                            @click="selectMonth(index)"
                            class="p-2 text-center cursor-pointer rounded hover:bg-gray-100"
                            :class="{'bg-blue-500 text-white': isSelectedMonth(index)}"
                        >
                            {{ month.substring(0, 3) }}
                        </div>
                        </div>
                    </div>
                    </div>
                    <div v-else class="h-9 px-2 text-center bg-blue-900 flex text-white justify-center items-center rounded-xl mt-3 w-full">
                        ข้อมูลทั้งหมด
                    </div>
                </div>
            </div>
            <!-- Income Tab -->
            <div class="flex w-full mt-1" v-if="tab == 1">
                <div class="w-2/5">
                    <div class="flex mt-1 w-full">
                        <div class="mt-2 w-full">
                            <div class="mt-2 flex items-center justify-between border h-7 rounded-lg px-3">
                                <div class="flex justify-center items-center">
                                    <div>
                                        <svg width="22" height="16" viewBox="0 0 22 16" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12.7514 8.71133C12.0527 8.71133 11.4614 8.46935 10.9774 7.98538C10.4934 7.50142 10.2515 6.91007 10.2515 6.21136C10.2515 5.51266 10.4934 4.92133 10.9774 4.43736C11.4614 3.95339 12.0527 3.71141 12.7514 3.71141C13.4501 3.71141 14.0415 3.95339 14.5254 4.43736C15.0094 4.92133 15.2514 5.51266 15.2514 6.21136C15.2514 6.91007 15.0094 7.50142 14.5254 7.98538C14.0415 8.46935 13.4501 8.71133 12.7514 8.71133ZM6.15528 11.8075C5.65818 11.8075 5.23262 11.6305 4.87861 11.2765C4.52461 10.9225 4.34761 10.4969 4.34761 9.99981V2.42291C4.34761 1.92581 4.52461 1.50025 4.87861 1.14623C5.23262 0.792234 5.65818 0.615234 6.15528 0.615234H19.3475C19.8446 0.615234 20.2702 0.792234 20.6242 1.14623C20.9782 1.50025 21.1552 1.92581 21.1552 2.42291V9.99981C21.1552 10.4969 20.9782 10.9225 20.6242 11.2765C20.2702 11.6305 19.8446 11.8075 19.3475 11.8075H6.15528ZM7.65526 10.3075H17.8476C17.8476 9.80882 18.0246 9.38286 18.3786 9.02966C18.7326 8.67644 19.1581 8.49983 19.6553 8.49983V3.92288C19.1565 3.92288 18.7306 3.74588 18.3774 3.39188C18.0242 3.03787 17.8476 2.61231 17.8476 2.11521H7.65526C7.65526 2.61393 7.47826 3.03988 7.12426 3.39308C6.77024 3.74628 6.34468 3.92288 5.84758 3.92288V8.49983C6.3463 8.49983 6.77226 8.67684 7.12546 9.03086C7.47866 9.38486 7.65526 9.81042 7.65526 10.3075ZM2.65533 15.3075C2.15821 15.3075 1.73266 15.1305 1.37866 14.7764C1.02466 14.4224 0.847656 13.9969 0.847656 13.4998V4.34598C0.847656 4.13348 0.919556 3.95537 1.06336 3.81163C1.20717 3.66788 1.38537 3.59601 1.59796 3.59601C1.81056 3.59601 1.98865 3.66788 2.13223 3.81163C2.27581 3.95537 2.34761 4.13348 2.34761 4.34598V13.4998C2.34761 13.5767 2.37966 13.6472 2.44378 13.7113C2.50788 13.7754 2.5784 13.8075 2.65533 13.8075H17.4245C17.637 13.8075 17.8151 13.8794 17.9588 14.0232C18.1026 14.167 18.1745 14.3452 18.1745 14.5578C18.1745 14.7704 18.1026 14.9485 17.9588 15.0921C17.8151 15.2357 17.637 15.3075 17.4245 15.3075H2.65533ZM6.15528 10.3075H5.84758V2.11521H6.15528C6.07195 2.11521 5.99983 2.14566 5.93893 2.20656C5.87803 2.26746 5.84758 2.33958 5.84758 2.42291V9.99981C5.84758 10.0831 5.87803 10.1553 5.93893 10.2162C5.99983 10.2771 6.07195 10.3075 6.15528 10.3075Z"
                                                fill="#11d17e" />
                                        </svg>
                                    </div>
                                    <div class="ml-2 text-[#11d17e] text-xs font-bold">
                                        {{ label1[0] }}: {{ formatNumber(data1[0]) }} ({{ calculatePercentage(data1[0], 0, data1) }})
                                    </div>                                </div>
                            </div>
                            <!-- Employee costs -->
                            <div class="flex items-center justify-between border h-7 rounded-lg px-3">
                                <div class="flex justify-center items-center">
                                    <div>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <mask id="mask0_2861_23329" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                                <rect width="24" height="24" fill="#D9D9D9" />
                                            </mask>
                                            <g mask="url(#mask0_2861_23329)">
                                                <path d="M13.7514 12.7113C13.0527 12.7113 12.4614 12.4694 11.9774 11.9854C11.4934 11.5014 11.2515 10.9101 11.2515 10.2114C11.2515 9.51266 11.4934 8.92133 11.9774 8.43736C12.4614 7.95339 13.0527 7.71141 13.7514 7.71141C14.4501 7.71141 15.0415 7.95339 15.5254 8.43736C16.0094 8.92133 16.2514 9.51266 16.2514 10.2114C16.2514 10.9101 16.0094 11.5014 15.5254 11.9854C15.0415 12.4694 14.4501 12.7113 13.7514 12.7113ZM7.15528 15.8075C6.65818 15.8075 6.23262 15.6305 5.87861 15.2765C5.52461 14.9225 5.34761 14.4969 5.34761 13.9998V6.42291C5.34761 5.92581 5.52461 5.50025 5.87861 5.14623C6.23262 4.79223 6.65818 4.61523 7.15528 4.61523H20.3475C20.8446 4.61523 21.2702 4.79223 21.6242 5.14623C21.9782 5.50025 22.1552 5.92581 22.1552 6.42291V13.9998C22.1552 14.4969 21.9782 14.9225 21.6242 15.2765C21.2702 15.6305 20.8446 15.8075 20.3475 15.8075H7.15528ZM8.65526 14.3075H18.8476C18.8476 13.8088 19.0246 13.3829 19.3786 13.0297C19.7326 12.6764 20.1581 12.4998 20.6553 12.4998V7.92288C20.1565 7.92288 19.7306 7.74588 19.3774 7.39188C19.0242 7.03787 18.8476 6.61231 18.8476 6.11521H8.65526C8.65526 6.61393 8.47826 7.03988 8.12426 7.39308C7.77024 7.74628 7.34468 7.92288 6.84758 7.92288V12.4998C7.3463 12.4998 7.77226 12.6768 8.12546 13.0309C8.47866 13.3849 8.65526 13.8104 8.65526 14.3075ZM3.65533 19.3075C3.15821 19.3075 2.73266 19.1305 2.37866 18.7764C2.02466 18.4224 1.84766 17.9969 1.84766 17.4998V8.34598C1.84766 8.13348 1.91956 7.95537 2.06336 7.81163C2.20717 7.66788 2.38537 7.59601 2.59796 7.59601C2.81056 7.59601 2.98865 7.66788 3.13223 7.81163C3.27581 7.95537 3.34761 8.13348 3.34761 8.34598V17.4998C3.34761 17.5767 3.37966 17.6472 3.44378 17.7113C3.50788 17.7754 3.5784 17.8075 3.65533 17.8075H18.4245C18.637 17.8075 18.8151 17.8794 18.9588 18.0232C19.1026 18.167 19.1745 18.3452 19.1745 18.5578C19.1745 18.7704 19.1026 18.9485 18.9588 19.0921C18.8151 19.2357 18.637 19.3075 18.4245 19.3075H3.65533ZM7.15528 14.3075H6.84758V6.11521H7.15528C7.07195 6.11521 6.99983 6.14566 6.93893 6.20656C6.87803 6.26746 6.84758 6.33958 6.84758 6.42291V13.9998C6.84758 14.0831 6.87803 14.1553 6.93893 14.2162C6.99983 14.2771 7.07195 14.3075 7.15528 14.3075Z" fill="#3630a6" />
                                            </g>
                                        </svg>
                                    </div>
                                    <div class="ml-2 text-[#3630a6] text-xs font-bold">
                                        {{ label1[1] }}: {{ formatNumber(data1[1]) }} ({{ calculatePercentage(data1[1], 1, data1) }})
                                    </div>
                                </div>
                            </div>
                            <!-- Contract costs -->
                            <div class="mt-2 flex items-center justify-between border h-7 rounded-lg px-3">
                                <div class="flex justify-center items-center">
                                    <div>
                                        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.7514 8.71133C12.0527 8.71133 11.4614 8.46935 10.9774 7.98538C10.4934 7.50142 10.2515 6.91007 10.2515 6.21136C10.2515 5.51266 10.4934 4.92133 10.9774 4.43736C11.4614 3.95339 12.0527 3.71141 12.7514 3.71141C13.4501 3.71141 14.0415 3.95339 14.5254 4.43736C15.0094 4.92133 15.2514 5.51266 15.2514 6.21136C15.2514 6.91007 15.0094 7.50142 14.5254 7.98538C14.0415 8.46935 13.4501 8.71133 12.7514 8.71133ZM6.15528 11.8075C5.65818 11.8075 5.23262 11.6305 4.87861 11.2765C4.52461 10.9225 4.34761 10.4969 4.34761 9.99981V2.42291C4.34761 1.92581 4.52461 1.50025 4.87861 1.14623C5.23262 0.792234 5.65818 0.615234 6.15528 0.615234H19.3475C19.8446 0.615234 20.2702 0.792234 20.6242 1.14623C20.9782 1.50025 21.1552 1.92581 21.1552 2.42291V9.99981C21.1552 10.4969 20.9782 10.9225 20.6242 11.2765C20.2702 11.6305 19.8446 11.8075 19.3475 11.8075H6.15528ZM7.65526 10.3075H17.8476C17.8476 9.80882 18.0246 9.38286 18.3786 9.02966C18.7326 8.67644 19.1581 8.49983 19.6553 8.49983V3.92288C19.1565 3.92288 18.7306 3.74588 18.3774 3.39188C18.0242 3.03787 17.8476 2.61231 17.8476 2.11521H7.65526C7.65526 2.61393 7.47826 3.03988 7.12426 3.39308C6.77024 3.74628 6.34468 3.92288 5.84758 3.92288V8.49983C6.3463 8.49983 6.77226 8.67684 7.12546 9.03086C7.47866 9.38486 7.65526 9.81042 7.65526 10.3075ZM2.65533 15.3075C2.15821 15.3075 1.73266 15.1305 1.37866 14.7764C1.02466 14.4224 0.847656 13.9969 0.847656 13.4998V4.34598C0.847656 4.13348 0.919556 3.95537 1.06336 3.81163C1.20717 3.66788 1.38537 3.59601 1.59796 3.59601C1.81056 3.59601 1.98865 3.66788 2.13223 3.81163C2.27581 3.95537 2.34761 4.13348 2.34761 4.34598V13.4998C2.34761 13.5767 2.37966 13.6472 2.44378 13.7113C2.50788 13.7754 2.5784 13.8075 2.65533 13.8075H17.4245C17.637 13.8075 17.8151 13.8794 17.9588 14.0232C18.1026 14.167 18.1745 14.3452 18.1745 14.5578C18.1745 14.7704 18.1026 14.9485 17.9588 15.0921C17.8151 15.2357 17.637 15.3075 17.4245 15.3075H2.65533ZM6.15528 10.3075H5.84758V2.11521H6.15528C6.07195 2.11521 5.99983 2.14566 5.93893 2.20656C5.87803 2.26746 5.84758 2.33958 5.84758 2.42291V9.99981C5.84758 10.0831 5.87803 10.1553 5.93893 10.2162C5.99983 10.2771 6.07195 10.3075 6.15528 10.3075Z" fill="#27d111" />
                                        </svg>
                                    </div>
                                    <div class="ml-2 text-[#27d111] text-xs font-bold">
                                        {{ label1[2] }}: {{ formatNumber(data1[2]) }} ({{ calculatePercentage(data1[2], 2, data1) }})
                                    </div>
                                </div>
                            </div>

                            <!-- Maintenance costs -->
                            <div class="mt-2 flex items-center justify-between border h-7 rounded-lg px-3">
                                <div class="flex justify-center items-center">
                                    <div>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <mask id="mask0_2861_23339" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                                <rect width="24" height="24" fill="#D9D9D9" />
                                            </mask>
                                            <g mask="url(#mask0_2861_23339)">
                                                <path d="M5.67498 18.5L5.15383 19.9769C5.12798 20.0494 5.08273 20.1098 5.0181 20.1582C4.95345 20.2065 4.87775 20.2307 4.791 20.2307H4.67948C4.58033 20.2307 4.49358 20.1932 4.41923 20.1182C4.34488 20.0432 4.3077 19.9557 4.3077 19.8557V18.5C3.81058 18.5 3.38503 18.3229 3.03102 17.9689C2.67701 17.6149 2.5 17.1894 2.5 16.6923V6.3077C2.5 5.81058 2.67701 5.38503 3.03102 5.03103C3.38503 4.67701 3.81058 4.5 4.3077 4.5H19.6923C20.1894 4.5 20.6149 4.67701 20.9689 5.03103C21.3229 5.38503 21.5 5.81058 21.5 6.3077V16.6923C21.5 17.1898 21.3229 17.6156 20.9689 17.9699C20.6149 18.3242 20.1894 18.5013 19.6923 18.5013V19.8807C19.6923 19.9789 19.6585 20.0618 19.591 20.1294C19.5234 20.1969 19.4405 20.2307 19.3423 20.2307H19.2077C19.1307 20.2307 19.0602 20.2093 18.9961 20.1665C18.932 20.1237 18.8872 20.0656 18.8615 19.9922L18.3596 18.5H5.67498ZM4.3077 17H19.6923C19.782 17 19.8557 16.9711 19.9134 16.9134C19.9711 16.8557 20 16.782 20 16.6923V6.3077C20 6.21795 19.9711 6.14423 19.9134 6.08653C19.8557 6.02883 19.782 5.99998 19.6923 5.99998H4.3077C4.21795 5.99998 4.14423 6.02883 4.08653 6.08653C4.02883 6.14423 3.99998 6.21795 3.99998 6.3077V16.6923C3.99998 16.782 4.02883 16.8557 4.08653 16.9134C4.14423 16.9711 4.21795 17 4.3077 17Z" fill="#ac6eeb" />
                                            </g>
                                        </svg>
                                    </div>
                                    <div class="ml-2 text-[#ac6eeb] text-xs font-bold">
                                        {{ label1[3] }}: {{ formatNumber(data1[3]) }} ({{ calculatePercentage(data1[3], 3, data1) }})
                                    </div>
                                </div>
                            </div>

                            <!-- Other costs -->
                            <div class="mt-2 flex items-center justify-between border h-7 rounded-lg px-3">
                                <div class="flex justify-center items-center">
                                    <div>
                                        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.86323 17.5771C1.45426 17.5771 1.10203 17.4294 0.806531 17.1339C0.511031 16.8384 0.363281 16.4861 0.363281 16.0772V1.57712C0.363281 1.16816 0.511031 0.815915 0.806531 0.520399C1.10203 0.224899 1.45426 0.0771484 1.86323 0.0771484H8.36326C8.77222 0.0771484 9.12446 0.224899 9.41998 0.520399C9.71548 0.815915 9.86323 1.16816 9.86323 1.57712V4.07715H18.1325C18.5414 4.07715 18.8937 4.2249 19.1892 4.5204C19.4847 4.81592 19.6325 5.16816 19.6325 5.57712V16.0772C19.6325 16.4861 19.4847 16.8384 19.1892 17.1339C18.8937 17.4294 18.5414 17.5771 18.1325 17.5771H1.86323ZM1.86323 16.0772H4.36326V13.5771H1.86323V16.0772ZM1.86323 12.0772H4.36326V9.57712H1.86323V12.0772ZM1.86323 8.07715H4.36326V5.57712H1.86323V8.07715ZM1.86323 4.07715H4.36326V1.57712H1.86323V4.07715ZM5.86323 16.0772H8.36326V13.5771H5.86323V16.0772ZM5.86323 12.0772H8.36326V9.57712H5.86323V12.0772ZM5.86323 8.07715H8.36326V5.57712H5.86323V8.07715ZM5.86323 4.07715H8.36326V1.57712H5.86323V4.07715ZM9.86323 16.0772H18.1325V5.57712H9.86323V8.07715H12.0556V9.57712H9.86323V12.0772H12.0556V13.5771H9.86323V16.0772ZM14.2479 9.57712V8.07715H15.7478V9.57712H14.2479ZM14.2479 13.5771V12.0772H15.7478V13.5771H14.2479Z" fill="#a1a1a1" />
                                        </svg>
                                    </div>
                                    <div class="ml-2 text-[#a1a1a1] text-xs font-bold">
                                        {{ label1[4] }}: {{ formatNumber(data1[4]) }} ({{ calculatePercentage(data1[4], 4, data1) }})
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-3/5">
                    <apexchart :options="options1" :series="series1"></apexchart>
                </div>
            </div>
            
            <!-- Expense Tab -->
            <div class="flex w-full mt-1" v-else-if="tab == 2">
                <div class="w-2/5">
                    <div class="flex mt-1 w-full">
                        <div class="mt-2 w-full">
                            <!-- Employee costs -->
                            <div class="flex items-center justify-between border h-7 rounded-lg px-3">
                                <div class="flex justify-center items-center">
                                    <div>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <mask id="mask0_2861_23329" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                                <rect width="24" height="24" fill="#D9D9D9" />
                                            </mask>
                                            <g mask="url(#mask0_2861_23329)">
                                                <path d="M13.7514 12.7113C13.0527 12.7113 12.4614 12.4694 11.9774 11.9854C11.4934 11.5014 11.2515 10.9101 11.2515 10.2114C11.2515 9.51266 11.4934 8.92133 11.9774 8.43736C12.4614 7.95339 13.0527 7.71141 13.7514 7.71141C14.4501 7.71141 15.0415 7.95339 15.5254 8.43736C16.0094 8.92133 16.2514 9.51266 16.2514 10.2114C16.2514 10.9101 16.0094 11.5014 15.5254 11.9854C15.0415 12.4694 14.4501 12.7113 13.7514 12.7113ZM7.15528 15.8075C6.65818 15.8075 6.23262 15.6305 5.87861 15.2765C5.52461 14.9225 5.34761 14.4969 5.34761 13.9998V6.42291C5.34761 5.92581 5.52461 5.50025 5.87861 5.14623C6.23262 4.79223 6.65818 4.61523 7.15528 4.61523H20.3475C20.8446 4.61523 21.2702 4.79223 21.6242 5.14623C21.9782 5.50025 22.1552 5.92581 22.1552 6.42291V13.9998C22.1552 14.4969 21.9782 14.9225 21.6242 15.2765C21.2702 15.6305 20.8446 15.8075 20.3475 15.8075H7.15528ZM8.65526 14.3075H18.8476C18.8476 13.8088 19.0246 13.3829 19.3786 13.0297C19.7326 12.6764 20.1581 12.4998 20.6553 12.4998V7.92288C20.1565 7.92288 19.7306 7.74588 19.3774 7.39188C19.0242 7.03787 18.8476 6.61231 18.8476 6.11521H8.65526C8.65526 6.61393 8.47826 7.03988 8.12426 7.39308C7.77024 7.74628 7.34468 7.92288 6.84758 7.92288V12.4998C7.3463 12.4998 7.77226 12.6768 8.12546 13.0309C8.47866 13.3849 8.65526 13.8104 8.65526 14.3075ZM3.65533 19.3075C3.15821 19.3075 2.73266 19.1305 2.37866 18.7764C2.02466 18.4224 1.84766 17.9969 1.84766 17.4998V8.34598C1.84766 8.13348 1.91956 7.95537 2.06336 7.81163C2.20717 7.66788 2.38537 7.59601 2.59796 7.59601C2.81056 7.59601 2.98865 7.66788 3.13223 7.81163C3.27581 7.95537 3.34761 8.13348 3.34761 8.34598V17.4998C3.34761 17.5767 3.37966 17.6472 3.44378 17.7113C3.50788 17.7754 3.5784 17.8075 3.65533 17.8075H18.4245C18.637 17.8075 18.8151 17.8794 18.9588 18.0232C19.1026 18.167 19.1745 18.3452 19.1745 18.5578C19.1745 18.7704 19.1026 18.9485 18.9588 19.0921C18.8151 19.2357 18.637 19.3075 18.4245 19.3075H3.65533ZM7.15528 14.3075H6.84758V6.11521H7.15528C7.07195 6.11521 6.99983 6.14566 6.93893 6.20656C6.87803 6.26746 6.84758 6.33958 6.84758 6.42291V13.9998C6.84758 14.0831 6.87803 14.1553 6.93893 14.2162C6.99983 14.2771 7.07195 14.3075 7.15528 14.3075Z" fill="#F5D65E" />
                                            </g>
                                        </svg>
                                    </div>
                                    <div class="ml-2 text-[#F5D65E] font-bold">
                                        {{ label2[0] }}: {{ formatNumber(data2[0] || 0) }} ({{ calculatePercentage(data2[0], 0, data2) }})
                                    </div>
                                </div>
                            </div>

                            <!-- Contract costs -->
                            <div class="mt-2 flex items-center justify-between border h-7 rounded-lg px-3">
                                <div class="flex justify-center items-center">
                                    <div>
                                        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.7514 8.71133C12.0527 8.71133 11.4614 8.46935 10.9774 7.98538C10.4934 7.50142 10.2515 6.91007 10.2515 6.21136C10.2515 5.51266 10.4934 4.92133 10.9774 4.43736C11.4614 3.95339 12.0527 3.71141 12.7514 3.71141C13.4501 3.71141 14.0415 3.95339 14.5254 4.43736C15.0094 4.92133 15.2514 5.51266 15.2514 6.21136C15.2514 6.91007 15.0094 7.50142 14.5254 7.98538C14.0415 8.46935 13.4501 8.71133 12.7514 8.71133ZM6.15528 11.8075C5.65818 11.8075 5.23262 11.6305 4.87861 11.2765C4.52461 10.9225 4.34761 10.4969 4.34761 9.99981V2.42291C4.34761 1.92581 4.52461 1.50025 4.87861 1.14623C5.23262 0.792234 5.65818 0.615234 6.15528 0.615234H19.3475C19.8446 0.615234 20.2702 0.792234 20.6242 1.14623C20.9782 1.50025 21.1552 1.92581 21.1552 2.42291V9.99981C21.1552 10.4969 20.9782 10.9225 20.6242 11.2765C20.2702 11.6305 19.8446 11.8075 19.3475 11.8075H6.15528ZM7.65526 10.3075H17.8476C17.8476 9.80882 18.0246 9.38286 18.3786 9.02966C18.7326 8.67644 19.1581 8.49983 19.6553 8.49983V3.92288C19.1565 3.92288 18.7306 3.74588 18.3774 3.39188C18.0242 3.03787 17.8476 2.61231 17.8476 2.11521H7.65526C7.65526 2.61393 7.47826 3.03988 7.12426 3.39308C6.77024 3.74628 6.34468 3.92288 5.84758 3.92288V8.49983C6.3463 8.49983 6.77226 8.67684 7.12546 9.03086C7.47866 9.38486 7.65526 9.81042 7.65526 10.3075ZM2.65533 15.3075C2.15821 15.3075 1.73266 15.1305 1.37866 14.7764C1.02466 14.4224 0.847656 13.9969 0.847656 13.4998V4.34598C0.847656 4.13348 0.919556 3.95537 1.06336 3.81163C1.20717 3.66788 1.38537 3.59601 1.59796 3.59601C1.81056 3.59601 1.98865 3.66788 2.13223 3.81163C2.27581 3.95537 2.34761 4.13348 2.34761 4.34598V13.4998C2.34761 13.5767 2.37966 13.6472 2.44378 13.7113C2.50788 13.7754 2.5784 13.8075 2.65533 13.8075H17.4245C17.637 13.8075 17.8151 13.8794 17.9588 14.0232C18.1026 14.167 18.1745 14.3452 18.1745 14.5578C18.1745 14.7704 18.1026 14.9485 17.9588 15.0921C17.8151 15.2357 17.637 15.3075 17.4245 15.3075H2.65533ZM6.15528 10.3075H5.84758V2.11521H6.15528C6.07195 2.11521 5.99983 2.14566 5.93893 2.20656C5.87803 2.26746 5.84758 2.33958 5.84758 2.42291V9.99981C5.84758 10.0831 5.87803 10.1553 5.93893 10.2162C5.99983 10.2771 6.07195 10.3075 6.15528 10.3075Z" fill="#008EF4" />
                                        </svg>
                                    </div>
                                    <div class="ml-2 text-[#008EF4] font-bold">
                                        {{ label2[1] }}: {{ formatNumber(data2[1] || 0) }} ({{ calculatePercentage(data2[1], 1, data2) }})
                                    </div>
                                </div>
                            </div>

                            <!-- Maintenance costs -->
                            <div class="mt-2 flex items-center justify-between border h-7 rounded-lg px-3">
                                <div class="flex justify-center items-center">
                                    <div>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <mask id="mask0_2861_23339" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                                <rect width="24" height="24" fill="#D9D9D9" />
                                            </mask>
                                            <g mask="url(#mask0_2861_23339)">
                                                <path d="M5.67498 18.5L5.15383 19.9769C5.12798 20.0494 5.08273 20.1098 5.0181 20.1582C4.95345 20.2065 4.87775 20.2307 4.791 20.2307H4.67948C4.58033 20.2307 4.49358 20.1932 4.41923 20.1182C4.34488 20.0432 4.3077 19.9557 4.3077 19.8557V18.5C3.81058 18.5 3.38503 18.3229 3.03102 17.9689C2.67701 17.6149 2.5 17.1894 2.5 16.6923V6.3077C2.5 5.81058 2.67701 5.38503 3.03102 5.03103C3.38503 4.67701 3.81058 4.5 4.3077 4.5H19.6923C20.1894 4.5 20.6149 4.67701 20.9689 5.03103C21.3229 5.38503 21.5 5.81058 21.5 6.3077V16.6923C21.5 17.1898 21.3229 17.6156 20.9689 17.9699C20.6149 18.3242 20.1894 18.5013 19.6923 18.5013V19.8807C19.6923 19.9789 19.6585 20.0618 19.591 20.1294C19.5234 20.1969 19.4405 20.2307 19.3423 20.2307H19.2077C19.1307 20.2307 19.0602 20.2093 18.9961 20.1665C18.932 20.1237 18.8872 20.0656 18.8615 19.9922L18.3596 18.5H5.67498ZM4.3077 17H19.6923C19.782 17 19.8557 16.9711 19.9134 16.9134C19.9711 16.8557 20 16.782 20 16.6923V6.3077C20 6.21795 19.9711 6.14423 19.9134 6.08653C19.8557 6.02883 19.782 5.99998 19.6923 5.99998H4.3077C4.21795 5.99998 4.14423 6.02883 4.08653 6.08653C4.02883 6.14423 3.99998 6.21795 3.99998 6.3077V16.6923C3.99998 16.782 4.02883 16.8557 4.08653 16.9134C4.14423 16.9711 4.21795 17 4.3077 17Z" fill="#D44769" />
                                            </g>
                                        </svg>
                                    </div>
                                    <div class="ml-2 text-[#D44769] font-bold">
                                        {{ label2[2] }}: {{ formatNumber(data2[2] || 0) }} ({{ calculatePercentage(data2[2], 2, data2) }})
                                    </div>
                                </div>
                            </div>

                            <!-- water costs -->
                            <div class="mt-2 flex items-center justify-between border h-7 rounded-lg px-3">
                                <div class="flex justify-center items-center">
                                    <div>
                                        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.86323 17.5771C1.45426 17.5771 1.10203 17.4294 0.806531 17.1339C0.511031 16.8384 0.363281 16.4861 0.363281 16.0772V1.57712C0.363281 1.16816 0.511031 0.815915 0.806531 0.520399C1.10203 0.224899 1.45426 0.0771484 1.86323 0.0771484H8.36326C8.77222 0.0771484 9.12446 0.224899 9.41998 0.520399C9.71548 0.815915 9.86323 1.16816 9.86323 1.57712V4.07715H18.1325C18.5414 4.07715 18.8937 4.2249 19.1892 4.5204C19.4847 4.81592 19.6325 5.16816 19.6325 5.57712V16.0772C19.6325 16.4861 19.4847 16.8384 19.1892 17.1339C18.8937 17.4294 18.5414 17.5771 18.1325 17.5771H1.86323ZM1.86323 16.0772H4.36326V13.5771H1.86323V16.0772ZM1.86323 12.0772H4.36326V9.57712H1.86323V12.0772ZM1.86323 8.07715H4.36326V5.57712H1.86323V8.07715ZM1.86323 4.07715H4.36326V1.57712H1.86323V4.07715ZM5.86323 16.0772H8.36326V13.5771H5.86323V16.0772ZM5.86323 12.0772H8.36326V9.57712H5.86323V12.0772ZM5.86323 8.07715H8.36326V5.57712H5.86323V8.07715ZM5.86323 4.07715H8.36326V1.57712H5.86323V4.07715ZM9.86323 16.0772H18.1325V5.57712H9.86323V8.07715H12.0556V9.57712H9.86323V12.0772H12.0556V13.5771H9.86323V16.0772ZM14.2479 9.57712V8.07715H15.7478V9.57712H14.2479ZM14.2479 13.5771V12.0772H15.7478V13.5771H14.2479Z" fill="#9A77FF" />
                                        </svg>
                                    </div>
                                    <div class="ml-2 text-[#9A77FF] font-bold">
                                        {{ label2[3] }}: {{ formatNumber(data2[3] || 0) }} ({{ calculatePercentage(data2[3], 3, data2) }})
                                    </div>
                                </div>
                            </div>

                            <!-- elec costs -->
                            <div class="mt-2 flex items-center justify-between border h-7 rounded-lg px-3">
                                <div class="flex justify-center items-center">
                                    <div>
                                        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.86323 17.5771C1.45426 17.5771 1.10203 17.4294 0.806531 17.1339C0.511031 16.8384 0.363281 16.4861 0.363281 16.0772V1.57712C0.363281 1.16816 0.511031 0.815915 0.806531 0.520399C1.10203 0.224899 1.45426 0.0771484 1.86323 0.0771484H8.36326C8.77222 0.0771484 9.12446 0.224899 9.41998 0.520399C9.71548 0.815915 9.86323 1.16816 9.86323 1.57712V4.07715H18.1325C18.5414 4.07715 18.8937 4.2249 19.1892 4.5204C19.4847 4.81592 19.6325 5.16816 19.6325 5.57712V16.0772C19.6325 16.4861 19.4847 16.8384 19.1892 17.1339C18.8937 17.4294 18.5414 17.5771 18.1325 17.5771H1.86323ZM1.86323 16.0772H4.36326V13.5771H1.86323V16.0772ZM1.86323 12.0772H4.36326V9.57712H1.86323V12.0772ZM1.86323 8.07715H4.36326V5.57712H1.86323V8.07715ZM1.86323 4.07715H4.36326V1.57712H1.86323V4.07715ZM5.86323 16.0772H8.36326V13.5771H5.86323V16.0772ZM5.86323 12.0772H8.36326V9.57712H5.86323V12.0772ZM5.86323 8.07715H8.36326V5.57712H5.86323V8.07715ZM5.86323 4.07715H8.36326V1.57712H5.86323V4.07715ZM9.86323 16.0772H18.1325V5.57712H9.86323V8.07715H12.0556V9.57712H9.86323V12.0772H12.0556V13.5771H9.86323V16.0772ZM14.2479 9.57712V8.07715H15.7478V9.57712H14.2479ZM14.2479 13.5771V12.0772H15.7478V13.5771H14.2479Z" fill="#F1B826" />
                                        </svg>
                                    </div>
                                    <div class="ml-2 text-[#F1B826] font-bold">
                                        {{ label2[4] }}: {{ formatNumber(data2[4] || 0) }} ({{ calculatePercentage(data2[4], 4, data2) }})
                                    </div>
                                </div>
                            </div>
                            <!-- Other costs -->
                            <div class="mt-2 flex items-center justify-between border h-7 rounded-lg px-3">
                                <div class="flex justify-center items-center">
                                    <div>
                                        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.86323 17.5771C1.45426 17.5771 1.10203 17.4294 0.806531 17.1339C0.511031 16.8384 0.363281 16.4861 0.363281 16.0772V1.57712C0.363281 1.16816 0.511031 0.815915 0.806531 0.520399C1.10203 0.224899 1.45426 0.0771484 1.86323 0.0771484H8.36326C8.77222 0.0771484 9.12446 0.224899 9.41998 0.520399C9.71548 0.815915 9.86323 1.16816 9.86323 1.57712V4.07715H18.1325C18.5414 4.07715 18.8937 4.2249 19.1892 4.5204C19.4847 4.81592 19.6325 5.16816 19.6325 5.57712V16.0772C19.6325 16.4861 19.4847 16.8384 19.1892 17.1339C18.8937 17.4294 18.5414 17.5771 18.1325 17.5771H1.86323ZM1.86323 16.0772H4.36326V13.5771H1.86323V16.0772ZM1.86323 12.0772H4.36326V9.57712H1.86323V12.0772ZM1.86323 8.07715H4.36326V5.57712H1.86323V8.07715ZM1.86323 4.07715H4.36326V1.57712H1.86323V4.07715ZM5.86323 16.0772H8.36326V13.5771H5.86323V16.0772ZM5.86323 12.0772H8.36326V9.57712H5.86323V12.0772ZM5.86323 8.07715H8.36326V5.57712H5.86323V8.07715ZM5.86323 4.07715H8.36326V1.57712H5.86323V4.07715ZM9.86323 16.0772H18.1325V5.57712H9.86323V8.07715H12.0556V9.57712H9.86323V12.0772H12.0556V13.5771H9.86323V16.0772ZM14.2479 9.57712V8.07715H15.7478V9.57712H14.2479ZM14.2479 13.5771V12.0772H15.7478V13.5771H14.2479Z" fill="#607D8B" />
                                        </svg>
                                    </div>
                                    <div class="ml-2 text-[#607D8B] font-bold">
                                        {{ label2[5] }}: {{ formatNumber(data2[5] || 0) }} ({{ calculatePercentage(data2[5], 5, data2) }})
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-3/5">
                    <apexchart :options="options2" :series="series2"></apexchart>
                </div>
            </div>
        </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import { parseIncomeRemark } from '@/components/hook/hook';

export default {
    components: {
        apexchart: VueApexCharts,
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        childFunction2: {
            type: Function,
            default: null
        },
        routeLink: {
            type: String,
            default: '/expenses'
        },
        allBuilding: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            tab: 1,
            viewMode: 'monthly',
            selectedDate: '',
            dashboardData: null,
            income: [],
            buildingIncome: [],
            years: [],
            months: [...Array(12).keys()].map((month) => month + 1),
            data1: [0, 0, 0, 0, 0],// Initialize with 0 for income
            data2: [0, 0, 0, 0, 0, 0], // Initialize with zeros for all expense categories
            label1: ['ค่าห้อง', 'ค่าน้ำ', 'ค่าไฟ', 'ค่าส่วนกลาง', 'ค่าอื่นๆ'],
            label2: ["ค่าจ้างพนักงาน", "ค่าจ้างทำของ", "ค่าซ่อมบำรุง", 'ค่าน้ำ', 'ค่าไฟ', "ค่าอื่นๆ"],
            series1: [], // For income chart
            series2: [], // For expense chart
            showDatePicker: false,
            currentYear: new Date().getFullYear(),
            monthNames: [
                'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
            ],
        };
    },
    created() {
        this.generateYears();
        this.selectedDate = new Date().getFullYear() + '-' + (new Date().getMonth() + 1).toString().padStart(2, '0');
        this.processData();
    },
    mounted() {
        this.getIncome();
    },
    watch: {
        data: {
            handler: function() {
                this.processData();
            },
            deep: true
        },
        allBuilding() {
            this.refreshWidgetData();
        }
    },
    methods: {
        toNumber(value) {
            const num = Number(value);
            return Number.isFinite(num) ? num : 0;
        },
        async getBuildingIdsForAggregation() {
            const buildingInfo = this.$store.state.buildingInfo;

            if (Array.isArray(buildingInfo)) {
                const ids = buildingInfo
                    .map((item) => item?.id || item?.attributes?.id)
                    .filter((id) => id !== undefined && id !== null);
                if (ids.length > 1) return ids;
            }

            if (Array.isArray(buildingInfo?.data)) {
                const ids = buildingInfo.data
                    .map((item) => item?.id || item?.attributes?.id)
                    .filter((id) => id !== undefined && id !== null);
                if (ids.length > 1) return ids;
            }

            try {
                const response = await fetch(
                    `https://api.resguru.app/api/buildings?filters[$or][0][user_owner][id][$eq]=${this.$store.state.userInfo.id}&filters[$or][1][users_admin][id][$in]=${this.$store.state.userInfo.id}&publicationState=live&populate=*`
                );
                const resp = await response.json();
                const ids = (resp?.data || [])
                    .map((item) => item?.id || item?.attributes?.id)
                    .filter((id) => id !== undefined && id !== null);

                if (ids.length) {
                    return ids;
                }
            } catch (error) {
                console.error('getBuildingIdsForAggregation error:', error);
            }

            return [this.$store.state.building].filter(
                (id) => id !== undefined && id !== null
            );
        },
        async fetchDashboardByBuilding(buildingId, month, year) {
            const response = await fetch(
                `https://api.resguru.app/api/getdashboard?buildingid=${buildingId}&month=${month}&year=${year}&allBuilding=0&user_id=${this.$store.state.userInfo.id}`
            );
            return response.json();
        },
        async fetchAllReceiptsByBuilding(buildingId) {
            const pageSize = 100;
            let page = 1;
            let pageCount = 1;
            const merged = [];

            while (page <= pageCount) {
                const response = await fetch(
                    `https://api.resguru.app/api/tenant-receipts?populate=*&filters[building][id][$eq]=${buildingId}&sort[0]=id:desc&pagination[page]=${page}&pagination[pageSize]=${pageSize}`
                );
                const resp = await response.json();

                merged.push(...(resp?.data || []));
                pageCount = Number(resp?.meta?.pagination?.pageCount) || 1;
                page += 1;
            }

            return merged;
        },
        async fetchAllBuildingIncomeByBuilding(buildingId) {
            const pageSize = 100;
            let page = 1;
            let pageCount = 1;
            const merged = [];

            while (page <= pageCount) {
                const response = await fetch(
                    `https://api.resguru.app/api/building-incomes?populate=*&filters[building][id][$eq]=${buildingId}&sort[0]=id:desc&pagination[page]=${page}&pagination[pageSize]=${pageSize}`
                );
                const resp = await response.json();

                merged.push(...(resp?.data || []));
                pageCount = Number(resp?.meta?.pagination?.pageCount) || 1;
                page += 1;
            }

            return merged;
        },
        getReceiptDate(item) {
            const attributes = item?.attributes || {};
            const dateValue = attributes.paymentDate || attributes.createdAt;
            const date = new Date(dateValue);
            return Number.isNaN(date.getTime()) ? null : date;
        },
        mergeExpenseByType(expenseLists) {
            const map = {};

            expenseLists.forEach((expenseList) => {
                if (!Array.isArray(expenseList)) return;

                expenseList.forEach((item) => {
                    const type = item?.type;
                    if (!type) return;
                    map[type] = this.toNumber(map[type]) + this.toNumber(item?.count);
                });
            });

            return Object.keys(map).map((type) => ({ type, count: map[type] }));
        },
        async getAggregatedAccounting(month, year) {
            if (!this.allBuilding) {
                const resp = await this.fetchDashboardByBuilding(this.$store.state.building, month, year);
                return {
                    receive: this.toNumber(resp?.accounting?.receive),
                    expense: Array.isArray(resp?.accounting?.expense) ? resp.accounting.expense : []
                };
            }

            const buildingIds = await this.getBuildingIdsForAggregation();
            const results = await Promise.allSettled(
                buildingIds.map((buildingId) => this.fetchDashboardByBuilding(buildingId, month, year))
            );

            const successResponses = results
                .filter((result) => result.status === 'fulfilled')
                .map((result) => result.value);

            if (!successResponses.length) {
                return { receive: 0, expense: [] };
            }

            return {
                receive: successResponses.reduce(
                    (sum, resp) => sum + this.toNumber(resp?.accounting?.receive),
                    0
                ),
                expense: this.mergeExpenseByType(
                    successResponses.map((resp) => resp?.accounting?.expense || [])
                )
            };
        },
        setViewMode(mode) {
            if (this.viewMode === mode) return;
            this.viewMode = mode;
            this.showDatePicker = false;
            this.refreshWidgetData();
        },
        refreshWidgetData() {
            this.getIncome();

            if (this.viewMode === 'all') {
                return;
            }

            this.getDashboard(this.selectedDate);
        },
        mapExpenseToSeries(expenseByType) {
            return [
                expenseByType["ค่าจ้างพนักงาน"] || 0,
                expenseByType["ค่าจ้างทำของ"] || 0,
                expenseByType["ค่าซ่อมบำรุง"] || 0,
                expenseByType["ค่าน้ำ"] || 0,
                expenseByType["ค่าไฟ"] || 0,
                (expenseByType["ค่าอื่นๆ"] || 0) +
                (expenseByType["ค่าอินเตอร์เน็ต"] || 0) +
                (expenseByType["ค่าเคเบิล"] || 0)
            ];
        },
        generateYears() {
            const currentYear = new Date().getFullYear();
            for (let year = currentYear - 10; year <= currentYear; year++) {
                this.years.push(year);
            }
        },
        // Fixed processData method to correctly handle the API data structure
        processData() {
            const sourceData = this.dashboardData || this.data;
            console.log("Processing data:", sourceData);
            
            // Method 1: API data has an accounting wrapper (which is the case with your data)
            if (sourceData && sourceData.accounting) {
                const accountingData = sourceData.accounting;
                
                // Process expense data
                if (Array.isArray(accountingData.expense)) {
                    let expenseByType = {};
                    accountingData.expense.forEach(item => {
                        expenseByType[item.type] = item.count || 0;
                    });

                    const counts = this.mapExpenseToSeries(expenseByType);
                    
                    this.data2 = counts;
                    this.series2 = counts;
                    console.log("Processed expense data from accounting:", counts);
                }
                
                // Process income data
                if (accountingData.receive !== undefined) {
                    const incomeValue = Math.floor(accountingData.receive);
                    this.data1 = [incomeValue];
                    this.series1 = [incomeValue];
                    console.log("Processed income data from accounting:", incomeValue);
                }
            } 
            // Method 2: Direct data structure without accounting wrapper
            else if (sourceData && (sourceData.expense || sourceData.receive !== undefined)) {
                // Process expense data
                if (Array.isArray(sourceData.expense)) {
                    let expenseByType = {};
                    sourceData.expense.forEach(item => {
                        expenseByType[item.type] = item.count || 0;
                    });

                    const counts = this.mapExpenseToSeries(expenseByType);
                    
                    this.data2 = counts;
                    this.series2 = counts;
                    console.log("Processed direct expense data:", counts);
                }
                
                // Process income data
                if (sourceData.receive !== undefined) {
                    const incomeValue = Math.floor(sourceData.receive || 0);
                    if (this.series1.every((value) => value === 0)) {
                        this.data1 = [incomeValue, 0, 0, 0, 0];
                        this.series1 = [incomeValue, 0, 0, 0, 0];
                    }
                }
            } else {
                console.warn("Data structure not recognized:", sourceData);
            }
        },
        getIncome() {
            const loading = this.$vs.loading();
            const loadFromAllBuildings = async (fetcher) => {
                const buildingIds = await this.getBuildingIdsForAggregation();
                const results = await Promise.allSettled(
                    buildingIds.map((buildingId) => fetcher(buildingId))
                );

                const merged = [];
                results
                    .filter((result) => result.status === 'fulfilled')
                    .forEach((result) => {
                        merged.push(...(result.value || []));
                    });

                // Prevent duplicates in case APIs return overlapping data.
                const uniqueById = new Map();
                merged.forEach((record) => {
                    if (record?.id != null) {
                        uniqueById.set(record.id, record);
                    }
                });
                return Array.from(uniqueById.values());
            };

            const loadReceipts = async () => {
                if (!this.allBuilding) {
                    return this.fetchAllReceiptsByBuilding(this.$store.state.building);
                }
                return loadFromAllBuildings((buildingId) => this.fetchAllReceiptsByBuilding(buildingId));
            };

            const loadBuildingIncome = async () => {
                if (!this.allBuilding) {
                    return this.fetchAllBuildingIncomeByBuilding(this.$store.state.building);
                }
                return loadFromAllBuildings((buildingId) => this.fetchAllBuildingIncomeByBuilding(buildingId));
            };

            Promise.all([loadReceipts(), loadBuildingIncome()])
                .then(([receiptData, buildingIncomeData]) => {
                    console.log("Return from getReceipt()", receiptData);
                    this.income = receiptData;
                    this.buildingIncome = buildingIncomeData;
                    this.processIncomeData();
                    if (this.viewMode === 'all') {
                        this.getAllTimeExpenseData();
                    }
                })
                .catch((error) => {
                    console.error('Error fetching tenant receipts:', error);
                    this.income = [];
                    this.buildingIncome = [];
                    this.processIncomeData();
                })
                .finally(() => {
                    loading.close();
                });
        },
        async getAllTimeExpenseData() {
            const loading = this.$vs.loading();
            try {
                const now = new Date();
                let startDate;

                if (this.income.length > 0) {
                    const minCreatedAt = this.income.reduce((minDate, item) => {
                        const receiptDate = this.getReceiptDate(item);
                        if (!receiptDate) return minDate;
                        return receiptDate < minDate ? receiptDate : minDate;
                    }, this.getReceiptDate(this.income[0]) || new Date());
                    startDate = new Date(minCreatedAt.getFullYear(), minCreatedAt.getMonth(), 1);
                } else {
                    startDate = new Date(now.getFullYear(), 0, 1);
                }

                const endDate = new Date(now.getFullYear(), now.getMonth(), 1);
                const expenseByType = {};
                const cursor = new Date(startDate);

                while (cursor <= endDate) {
                    const year = String(cursor.getFullYear());
                    const month = String(cursor.getMonth() + 1).padStart(2, '0');

                    const accounting = await this.getAggregatedAccounting(month, year);
                    const monthlyExpense = accounting?.expense || [];

                    monthlyExpense.forEach((item) => {
                        const type = item?.type;
                        if (!type) return;
                        expenseByType[type] = (expenseByType[type] || 0) + Number(item.count || 0);
                    });

                    cursor.setMonth(cursor.getMonth() + 1);
                }

                const counts = this.mapExpenseToSeries(expenseByType);
                this.data2 = counts;
                this.series2 = counts;
            } catch (error) {
                console.error('Error fetching all-time expense data:', error);
            } finally {
                loading.close();
            }
        },
        processIncomeData() {
            // Initialize values for each category
            let roomTotal = 0;
            let waterTotal = 0;
            let electricTotal = 0;
            let commonTotal = 0;
            let othersTotal = 0;
            
            // Process each income record
            const [selectedYear, selectedMonth] = this.selectedDate
                ? this.selectedDate.split('-').map((value) => parseInt(value, 10))
                : [null, null];

            this.income.forEach(item => {
                const receiptDate = this.getReceiptDate(item);
                if (!receiptDate) {
                    return;
                }
                const createdYear = receiptDate.getFullYear();
                const createdMonth = receiptDate.getMonth() + 1;

                if (this.viewMode === 'monthly' && selectedYear && selectedMonth) {
                    if (createdYear !== selectedYear || createdMonth !== selectedMonth) {
                        return;
                    }
                }

                const attributes = item.attributes || {};
                const roomPrice = this.toNumber(attributes.roomPrice);
                const waterPrice = this.toNumber(attributes.waterPrice);
                const electricPrice = this.toNumber(attributes.electricPrice);
                const communalPrice = this.toNumber(attributes.communalPrice);
                const otherPrice = this.toNumber(attributes.otherPrice);
                const categorizedTotal = roomPrice + waterPrice + electricPrice + communalPrice + otherPrice;

                roomTotal += roomPrice;
                waterTotal += waterPrice;
                electricTotal += electricPrice;
                commonTotal += communalPrice;
                othersTotal += otherPrice;

                if (categorizedTotal <= 0) {
                    const fallbackPaid = this.toNumber(attributes.paidAmount || attributes.amount);
                    othersTotal += fallbackPaid;
                }
            });

            // Fold in manually-entered income (categories share the same
            // names as the chart buckets).
            this.buildingIncome.forEach(item => {
                const dateValue = item?.attributes?.date;
                const incomeDate = dateValue ? new Date(dateValue) : null;
                if (!incomeDate || Number.isNaN(incomeDate.getTime())) {
                    return;
                }

                if (this.viewMode === 'monthly' && selectedYear && selectedMonth) {
                    if (incomeDate.getFullYear() !== selectedYear || incomeDate.getMonth() + 1 !== selectedMonth) {
                        return;
                    }
                }

                const category = parseIncomeRemark(item.attributes.remark).category;
                const amount = this.toNumber(item.attributes.amount);
                if (category === 'ค่าห้อง') roomTotal += amount;
                else if (category === 'ค่าน้ำ') waterTotal += amount;
                else if (category === 'ค่าไฟ') electricTotal += amount;
                else if (category === 'ค่าส่วนกลาง') commonTotal += amount;
                else othersTotal += amount;
            });

            // Update the income data for the chart
            // this.incomeData = ;
            this.data1 = [roomTotal, waterTotal, electricTotal, commonTotal, othersTotal];
            this.series1 = [roomTotal, waterTotal, electricTotal, commonTotal, othersTotal];
        },
        // And make sure the getDashboard method simply assigns the entire API response to this.data
        getDashboard(date_data) {
            if (!date_data) return;

            let parts = date_data.split('-');
            let year = parts[0];
            let month = parts[1];
            
            console.log('Year:', year);
            console.log('Month:', month);
            
            // Reset data while fetching
            this.data1 = [0, 0, 0, 0, 0];
            this.data2 = [0, 0, 0, 0, 0, 0];
            this.series1 = [0, 0, 0, 0, 0];
            this.series2 = [0, 0, 0, 0, 0, 0];
            
            this.getAggregatedAccounting(month, year)
                .then((accounting) => {
                    this.dashboardData = accounting || { receive: 0, expense: [] };
                    this.processData();
                    this.processIncomeData();
                })
                .catch(error => {
                    console.error("Error fetching dashboard data:", error);
                });
        },
        // formatNumber(num) {
        //     if (num === undefined || num === null) return '0';
        //     return new Intl.NumberFormat().format(num);
        // }
        formatNumber(num) {
            if (num === undefined || num === null) return '0 ฿';
            return new Intl.NumberFormat('th-TH', {
                style: 'currency',
                currency: 'THB',
                currencyDisplay: 'symbol',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(num);
        },
        changeYear(amount) {
            this.currentYear += amount;
        },
        
        selectMonth(monthIndex) {
            const month = String(monthIndex + 1).padStart(2, '0');
            this.selectedDate = `${this.currentYear}-${month}`;
            this.getDashboard(this.selectedDate);
            this.showDatePicker = false;
        },
        
        isSelectedMonth(monthIndex) {
            if (!this.selectedDate) return false;
            const [year, month] = this.selectedDate.split('-');
            return parseInt(year) === this.currentYear && parseInt(month) === monthIndex + 1;
        },
        
        formatMonthYear(dateString) {
            if (!dateString) return '';
            
            const [year, month] = dateString.split('-');
            return `${this.monthNames[parseInt(month) - 1]} ${year}`;
        },
        calculatePercentage(value, index, dataArray) {
            const total = dataArray.reduce((sum, item) => sum + (Number(item) || 0), 0);
            if (total === 0) return '0%';
            const percentage = ((value / total) * 100).toFixed(1);
            return `${percentage}%`;
        },
        navigateToExpensesPage() {
            // Use the routeLink prop if provided, otherwise use a default path
            const path = this.routeLink || '/expenses';
            this.$router.push(path);
        },
    },
    computed: {
        options1() {
            return {
                chart: {
                    type: "donut",
                },
                dataLabels: {
                    enabled: false,
                },
                legend: {
                    show: false,
                },
                labels: this.label1,
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                total: {
                                    show: true,
                                    label: "รายรับทั้งหมด",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    color: "#6B7490",
                                    fontFamily: "Prompt",
                                    formatter: () => {
                                        const total1 = this.data1.reduce((sum, value) => sum + (value || 0), 0);
                                        return this.formatNumber(total1);
                                    }
                                },
                            },
                        },
                    },
                },
                tooltip: {
                    y: {
                        formatter: (val) => this.formatNumber(val)
                    }
                },
                colors: ['#11d17e', '#3630a6', '#27d111', '#ac6eeb', '#a1a1a1'],
            };
        },
        options2() {
            return {
                chart: {
                    type: "donut",
                },
                dataLabels: {
                    enabled: false,
                },
                legend: {
                    show: false,
                },
                labels: this.label2,
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                total: {
                                    show: true,
                                    label: "รายจ่ายทั้งหมด",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    color: "#6B7490",
                                    fontFamily: "Prompt",
                                    formatter: () => {
                                        const total2 = this.data2.reduce((sum, value) => sum + (value || 0), 0);
                                        return this.formatNumber(total2);
                                    }
                                },
                            },
                        },
                    },
                },
                tooltip: {
                    y: {
                        formatter: (val) => this.formatNumber(val)
                    }
                },
                colors: ["#F5D65E", "#008EF4", "#D44769", "#9A77FF", "#F1B826", "#607D8B"]
            };
        }
    },
};
</script>
<style scoped>
#payment {
    background-color: white;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.font-bold {
    font-weight: 700;
}

.text-xs {
    font-size: 0.75rem;
}

.text-sm {
    font-size: 0.875rem;
}

.text-xl {
    font-size: 1.25rem;
}

.z-10 {
  z-index: 10;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.grid {
  display: grid;
}

.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.gap-2 {
  gap: 0.5rem;
}
</style>